export const capitalizeEngine = engine => {

  return engine[0].toUpperCase() + engine.slice(1);

}